const vyalorAssets = window.VYALOR_ASSETS || {};
const vyalorVariants = window.VYALOR_VARIANTS || null;
const vyalorCartAssets = window.VYALOR_CART_ASSETS || {};

const productData = {
  pro: {
    label: "VYALOR Pro",
    short: "Premium portable model for daily peptide storage, GLP-1 medication, insulin pens and travel routines.",
    image: vyalorAssets.proImage || "assets/vyalor-pro-product-new.png",
    benefits: "Dedicated storage, digital monitoring, portable power and a premium organized interior for daily use.",
    capacity: "Capacity: 12-15 vials or 3-5 insulin pens, depending on packaging and vial size.",
    specs: "223 x 120 x 136 mm exterior. Adjustable 0-18 C cooling.",
    single: { price: "$249", compare: "$299", save: "Pro portable system" },
    bundle: { price: "$449", compare: "$498", save: "Save $49 - $224.50 / unit" },
  },
  promax: {
    label: "VYALOR Pro Max",
    short: "Larger-capacity flagship model for extended protocols, dual-layer organization and longer travel days.",
    image: vyalorAssets.promaxImage || "assets/vyalor-promax-product-new.png",
    benefits: "Expanded storage, enhanced organization, digital monitoring and a flexible setup for serious routines.",
    capacity: "Capacity: 30-40 vials or 6-10 insulin pens, depending on packaging and vial size.",
    specs: "235 x 183 x 100 mm exterior. Dual-layer interior, 13600mAh battery and 18h+ runtime.",
    single: { price: "$349", compare: "$399", save: "Pro Max capacity system" },
    bundle: { price: "$599", compare: "$698", save: "Save $99 - $299.50 / unit" },
  },
};

let selectedSize = "pro";
let selectedPackage = "single";
let selectedPlug = "UK";

const $ = (selector, root = document) => root.querySelector(selector);
const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

const cartDrawer = $("[data-cart-drawer]");
const cartBackdrop = $("[data-cart-backdrop]");
const cartDrawerItems = $("[data-cart-drawer-items]");
const cartDrawerFooter = $("[data-cart-drawer-footer]");
const cartDrawerCount = $("[data-cart-drawer-count]");
const cartDrawerSubtotal = $("[data-cart-drawer-subtotal]");

function setText(selector, value) {
  const node = $(selector);
  if (node) node.textContent = value;
}

function escapeHtml(value) {
  return String(value || "")
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function formatMoney(cents) {
  const currency = window.Shopify?.currency?.active || "USD";
  try {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency,
    }).format((Number(cents) || 0) / 100);
  } catch {
    return `$${((Number(cents) || 0) / 100).toFixed(2)}`;
  }
}

function updateCartCount(count) {
  $$("[data-cart-count]").forEach((node) => {
    node.textContent = String(count || 0);
    node.classList.toggle("is-empty", !count);
  });
  if (cartDrawerCount) {
    cartDrawerCount.textContent = `${count || 0} ${count === 1 ? "item" : "items"}`;
  }
}

function getCartItemImage(item) {
  if (item.image) return item.image;
  if ((item.product_title || "").toLowerCase().includes("max") && vyalorCartAssets.promaxImage) {
    return vyalorCartAssets.promaxImage;
  }
  return vyalorCartAssets.fallbackImage || "";
}

function renderCartDrawer(cart) {
  if (!cartDrawerItems) return;

  updateCartCount(cart.item_count);
  if (cartDrawerSubtotal) cartDrawerSubtotal.textContent = formatMoney(cart.total_price);

  if (!cart.items.length) {
    cartDrawerItems.innerHTML = `
      <div class="cart-drawer-empty">
        <h3>Your cart is empty.</h3>
        <p>Choose VYALOR Pro or VYALOR Pro Max to build your portable peptide storage system.</p>
        <a class="button" href="/#shop">Shop Systems</a>
      </div>
    `;
    if (cartDrawerFooter) cartDrawerFooter.hidden = true;
    return;
  }

  cartDrawerItems.innerHTML = cart.items
    .map((item, index) => {
      const line = index + 1;
      const image = getCartItemImage(item);
      const variant = item.variant_title && item.variant_title !== "Default Title" ? item.variant_title : "";
      const compare = item.original_line_price > item.final_line_price
        ? `<del>${formatMoney(item.original_line_price)}</del>`
        : "";

      return `
        <article class="drawer-cart-item">
          ${image ? `<img src="${escapeHtml(image)}" alt="${escapeHtml(item.product_title)}" loading="lazy">` : ""}
          <div>
            <strong class="drawer-cart-title">${escapeHtml(item.product_title)}</strong>
            ${variant ? `<span class="drawer-cart-variant">${escapeHtml(variant)}</span>` : ""}
            <div class="drawer-cart-tools">
              <div class="drawer-cart-qty" aria-label="Quantity">
                <button type="button" data-cart-quantity data-line="${line}" data-quantity="${Math.max(0, item.quantity - 1)}" aria-label="Decrease">-</button>
                <span>${item.quantity}</span>
                <button type="button" data-cart-quantity data-line="${line}" data-quantity="${item.quantity + 1}" aria-label="Increase">+</button>
              </div>
              <button class="drawer-cart-remove" type="button" data-cart-remove data-line="${line}" aria-label="Remove">
                <svg viewBox="0 0 24 24"><path d="M3 6h18" /><path d="M8 6V4h8v2" /><path d="m10 11 .5 7" /><path d="m14 11-.5 7" /><path d="M6 6l1 15h10l1-15" /></svg>
              </button>
            </div>
          </div>
          <div class="drawer-cart-price">
            <strong>${formatMoney(item.final_line_price)}</strong>
            ${compare}
          </div>
        </article>
      `;
    })
    .join("");

  if (cartDrawerFooter) cartDrawerFooter.hidden = false;
}

async function fetchCart() {
  const response = await fetch("/cart.js", {
    headers: { Accept: "application/json" },
  });
  if (!response.ok) throw new Error("Could not load cart");
  return response.json();
}

async function refreshCartDrawer() {
  const cart = await fetchCart();
  renderCartDrawer(cart);
  return cart;
}

function openCartDrawer() {
  if (!cartDrawer || !cartBackdrop) return;
  cartDrawer.classList.add("is-open");
  cartBackdrop.hidden = false;
  requestAnimationFrame(() => cartBackdrop.classList.add("is-open"));
  cartDrawer.setAttribute("aria-hidden", "false");
  document.body.classList.add("cart-drawer-open");
}

function closeCartDrawer() {
  if (!cartDrawer || !cartBackdrop) return;
  cartDrawer.classList.remove("is-open");
  cartBackdrop.classList.remove("is-open");
  cartDrawer.setAttribute("aria-hidden", "true");
  document.body.classList.remove("cart-drawer-open");
  setTimeout(() => {
    if (!cartBackdrop.classList.contains("is-open")) cartBackdrop.hidden = true;
  }, 240);
}

async function changeCartLine(line, quantity) {
  if (cartDrawer) cartDrawer.classList.add("cart-drawer-loading");
  try {
    const response = await fetch("/cart/change.js", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json",
      },
      body: JSON.stringify({ line, quantity }),
    });
    if (!response.ok) throw new Error("Could not update cart");
    renderCartDrawer(await response.json());
  } finally {
    if (cartDrawer) cartDrawer.classList.remove("cart-drawer-loading");
  }
}

function setActive(buttons, activeButton) {
  buttons.forEach((button) => button.classList.toggle("is-active", button === activeButton));
}

function getSelectedVariantKey() {
  return `${selectedSize}_${selectedPackage}_${selectedPlug}`;
}

function updateCartForm() {
  const addButton = $("[data-add-to-cart]");
  const buyNowButton = $("[data-buy-now]");
  const variantInput = $("[data-selected-variant-id]");
  const purchaseButtons = [addButton, buyNowButton].filter(Boolean);

  if (!addButton) return;

  if (!vyalorVariants) {
    purchaseButtons.forEach((button) => {
      button.disabled = false;
      button.removeAttribute("aria-disabled");
    });
    addButton.textContent = "Protect Your Peptides";
    if (buyNowButton) buyNowButton.textContent = "Buy Now";
    return;
  }

  const variantId = vyalorVariants[getSelectedVariantKey()] || "";
  if (variantInput) {
    variantInput.value = variantId;
  }

  purchaseButtons.forEach((button) => {
    button.disabled = !variantId;
    button.setAttribute("aria-disabled", String(!variantId));
  });
  addButton.textContent = variantId ? "Protect Your Peptides" : "Set variant in Shopify";
  if (buyNowButton) buyNowButton.textContent = variantId ? "Buy Now" : "Set variant in Shopify";
}

function updateShop() {
  const product = productData[selectedSize];
  const chosen = product[selectedPackage];

  $$("[data-product-name]").forEach((node) => {
    node.textContent = product.label;
  });

  $$("[data-product-img]").forEach((node) => {
    node.src = product.image;
    node.alt = product.label;
  });

  setText("[data-single-price]", product.single.price);
  setText("[data-single-compare]", product.single.compare);
  setText("[data-single-save]", product.single.save);
  setText("[data-bundle-price]", product.bundle.price);
  setText("[data-bundle-compare]", product.bundle.compare);
  setText("[data-bundle-save]", product.bundle.save);

  setText("#previewTitle", product.label);
  setText("#previewText", product.short);
  setText("#benefitsText", product.benefits);
  setText("#capacityText", product.capacity);
  setText("#specText", product.specs);
  setText("#selectedPlug", `${selectedPlug} Plug Kit`);
  setText("#selectedPrice", chosen.price);
  setText("#selectedCompare", chosen.compare);
  setText("#stickyName", product.label);
  setText("#stickyPrice", chosen.price);
  setText("#stickyPlug", `${selectedPlug} plug kit`);
  updateCartForm();
}

$$("[data-size]").forEach((button) => {
  button.addEventListener("click", () => {
    selectedSize = button.dataset.size;
    setActive($$("[data-size]"), button);
    updateShop();
  });
});

$$("[data-package]").forEach((button) => {
  button.addEventListener("click", () => {
    selectedPackage = button.dataset.package;
    setActive($$("[data-package]"), button);
    updateShop();
  });
});

$$("[data-plug]").forEach((button) => {
  button.addEventListener("click", () => {
    selectedPlug = button.dataset.plug;
    setActive($$("[data-plug]"), button);
    updateShop();
  });
});

$$(".thumb").forEach((button) => {
  button.addEventListener("click", () => {
    const heroMainImage = $("#heroMainImage");
    if (heroMainImage) heroMainImage.src = button.dataset.hero;
    setActive($$(".thumb"), button);
  });
});

const menuButton = $("#menuButton");
const mobileNav = $("#mobileNav");
if (menuButton && mobileNav) {
  menuButton.addEventListener("click", () => {
    mobileNav.classList.toggle("is-open");
  });
}

$$(".mobile-nav a").forEach((link) => {
  link.addEventListener("click", () => mobileNav?.classList.remove("is-open"));
});

const reviewTrack = $("#reviewTrack");
const reviewPrev = $("[data-review-prev]");
const reviewNext = $("[data-review-next]");

if (reviewPrev && reviewTrack) {
  reviewPrev.addEventListener("click", () => {
    reviewTrack.scrollBy({ left: -380, behavior: "smooth" });
  });
}

if (reviewNext && reviewTrack) {
  reviewNext.addEventListener("click", () => {
    reviewTrack.scrollBy({ left: 380, behavior: "smooth" });
  });
}

function updateStickyCartVisibility() {
  document.body.classList.toggle("cart-visible", window.scrollY > 2600);
}

window.addEventListener("scroll", updateStickyCartVisibility, { passive: true });
window.addEventListener("hashchange", () => setTimeout(updateStickyCartVisibility, 80));

$$("[data-add-to-cart], .package-card").forEach((button) => {
  button.addEventListener("keydown", (event) => {
    if (event.key === "Enter" || event.key === " ") {
      event.currentTarget.click();
    }
  });
});

$$("[data-cart-open]").forEach((trigger) => {
  trigger.addEventListener("click", async (event) => {
    event.preventDefault();
    try {
      await refreshCartDrawer();
      openCartDrawer();
    } catch {
      window.location.href = trigger.getAttribute("href") || "/cart";
    }
  });
});

$$("[data-cart-close]").forEach((trigger) => {
  trigger.addEventListener("click", closeCartDrawer);
});

if (cartBackdrop) {
  cartBackdrop.addEventListener("click", closeCartDrawer);
}

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape") closeCartDrawer();
});

$$(".shopify-cart-form").forEach((form) => {
  form.addEventListener("submit", async (event) => {
    const action = form.getAttribute("action") || "";
    if (!action.includes("/cart/add")) return;

    event.preventDefault();
    const submitButton = event.submitter && event.submitter.matches("button") ? event.submitter : form.querySelector("button[type='submit']");
    const originalText = submitButton?.textContent;

    try {
      if (submitButton) {
        submitButton.disabled = true;
        submitButton.textContent = "Adding...";
      }
      const response = await fetch(action, {
        method: "POST",
        body: new FormData(form),
        headers: { Accept: "application/json" },
      });
      if (!response.ok) throw new Error("Could not add item");
      await refreshCartDrawer();
      openCartDrawer();
    } catch (error) {
      console.error(error);
      HTMLFormElement.prototype.submit.call(form);
    } finally {
      if (submitButton) {
        submitButton.disabled = false;
        submitButton.textContent = originalText || "Protect Your Peptides";
      }
    }
  });
});

document.addEventListener("click", async (event) => {
  const removeButton = event.target.closest("[data-cart-remove]");
  if (removeButton) {
    await changeCartLine(Number(removeButton.dataset.line), 0);
    return;
  }

  const quantityButton = event.target.closest("[data-cart-quantity]");
  if (quantityButton) {
    await changeCartLine(Number(quantityButton.dataset.line), Number(quantityButton.dataset.quantity));
  }
});

if ($("[data-size]") || $("[data-add-to-cart]")) {
  updateShop();
}
updateStickyCartVisibility();
refreshCartDrawer().catch(() => {});
